<agr-form-dialog
  [formGroup]="formGroup"
  (confirm)="confirm($event)"
  (cancel)="cancel()"
  [data]="data"
  [disableSubmitButtonOnFormInvalid]="true"
  data-test="threshold-settings-dialog"
>
  <section>
    <h3>{{ 'threshold-settings.with-measurement.title' | translate }}</h3>
    <p>{{ 'threshold-settings.with-measurement.description' | translate }}</p>

    <div class="spacing--margin-top field-block">
      <div class="field-title">
        {{ 'threshold-settings.minimum-height-with-measurement.label' | translate }}
      </div>
      <mat-form-field
        appearance="outline"
        class="large-width-field"
        data-test="threshold-settings-dialog__minimum-height-with-measurement"
      >
        <input
          matInput
          type="number"
          formControlName="minimumHeightWithMeasurement"
          autocomplete="off"
          [attr.aria-label]="'threshold-settings.minimum-height-with-measurement.label' | translate"
        />
        <mat-error *ngIf="formGroup.get('minimumHeightWithMeasurement')?.hasError('required')">
          {{ 'threshold-settings.minimum-height-with-measurement.required' | translate }}
        </mat-error>
        <mat-error *ngIf="formGroup.get('minimumHeightWithMeasurement')?.hasError('min')">
          {{ 'threshold-settings.minimum-height-with-measurement.min' | translate }}
        </mat-error>
        <mat-error *ngIf="formGroup.get('minimumHeightWithMeasurement')?.hasError('max')">
          {{ 'threshold-settings.minimum-height-with-measurement.max' | translate }}
        </mat-error>
        <mat-error *ngIf="formGroup.get('minimumHeightWithMeasurement')?.hasError('pattern')">
          {{ 'threshold-settings.minimum-height-with-measurement.step' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="spacing--margin-top field-block">
      <div class="field-title">
        {{ 'threshold-settings.minimum-age-with-measurement.label' | translate }}
      </div>
      <mat-form-field
        appearance="outline"
        class="large-width-field"
        data-test="threshold-settings-dialog__minimum-age-with-measurement"
      >
        <input
          matInput
          type="number"
          step="0.5"
          formControlName="minAgeWithMeasurement"
          autocomplete="off"
          [attr.aria-label]="'threshold-settings.minimum-age-with-measurement.label' | translate"
        />
        <mat-error *ngIf="formGroup.get('minAgeWithMeasurement')?.hasError('required')">
          {{ 'threshold-settings.minimum-age-with-measurement.required' | translate }}
        </mat-error>
        <mat-error *ngIf="formGroup.get('minAgeWithMeasurement')?.hasError('min')">
          {{ 'threshold-settings.minimum-age-with-measurement.min' | translate }}
        </mat-error>
        <mat-error *ngIf="formGroup.get('minAgeWithMeasurement')?.hasError('max')">
          {{ 'threshold-settings.minimum-age-with-measurement.max' | translate }}
        </mat-error>
        <mat-error *ngIf="formGroup.get('minAgeWithMeasurement')?.hasError('step')">
          {{ 'threshold-settings.minimum-age-with-measurement.step' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
  </section>

  <section class="spacing--margin-top">
    <h3>{{ 'threshold-settings.inseminate-now.title' | translate }}</h3>
    <p>{{ 'threshold-settings.inseminate-now.description' | translate }}</p>

    <div class="spacing--margin-top field-block">
      <div class="field-title">
        {{ 'threshold-settings.minimum-age-inseminate-now.label' | translate }}
      </div>
      <mat-form-field
        appearance="outline"
        class="large-width-field"
        data-test="threshold-settings-dialog__minimum-age-inseminate-now"
      >
        <input
          matInput
          type="number"
          step="0.5"
          formControlName="minAgeWithoutMeasurement"
          autocomplete="off"
          [attr.aria-label]="'threshold-settings.minimum-age-inseminate-now.label' | translate"
        />
        <mat-error *ngIf="formGroup.get('minAgeWithoutMeasurement')?.hasError('required')">
          {{ 'threshold-settings.minimum-age-inseminate-now.required' | translate }}
        </mat-error>
        <mat-error *ngIf="formGroup.get('minAgeWithoutMeasurement')?.hasError('min')">
          {{ 'threshold-settings.minimum-age-inseminate-now.min' | translate }}
        </mat-error>
        <mat-error *ngIf="formGroup.get('minAgeWithoutMeasurement')?.hasError('max')">
          {{ 'threshold-settings.minimum-age-inseminate-now.max' | translate }}
        </mat-error>
        <mat-error *ngIf="formGroup.get('minAgeWithoutMeasurement')?.hasError('step')">
          {{ 'threshold-settings.minimum-age-inseminate-now.step' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="spacing--margin-top" *ngIf="formGroup.hasError('ageRange')">
      <mat-error style="display: block; color: #f44336">
        {{ 'threshold-settings.age-range' | translate }}
      </mat-error>
    </div>
  </section>
</agr-form-dialog>
